import { render } from "./Instruments.vue?vue&type=template&id=5f6e6a02&scoped=true"
import script from "./Instruments.vue?vue&type=script&lang=js"
export * from "./Instruments.vue?vue&type=script&lang=js"

import "./Instruments.vue?vue&type=style&index=0&id=5f6e6a02&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6e6a02"]])

export default __exports__